<template>
  <div>
    <el-form
      class="login-form form-custom"
      ref="form"
      label-position="top"
      label-width="80px"
      @submit.native.prevent
      @keyup.enter.native="submit"
      :hide-required-asterisk="true"
      :rules="rules"
      :model="form"
    >
      <el-row :class="{ fr: $i18n.locale === 'cn' }" :gutter="12">
        <el-col :span="12">
          <el-form-item class="form-item-primary" prop="firstName">
            <BaseInput
              :autofocus="$i18n.locale === 'en' && !isMobile"
              :tabIndexNum="$i18n.locale === 'en' ? '1' : '2'"
              v-model="form.firstName"
              @blur="nameFilter('firstName')"
              :validate-event="Boolean(form.firstName)"
              :placeholer="$t('login.register.firstName')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item class="form-item-primary" prop="lastName">
            <BaseInput
              :autofocus="$i18n.locale === 'cn' && !isMobile"
              :tabIndexNum="$i18n.locale === 'en' ? '2' : '1'"
              v-model="form.lastName"
              @blur="nameFilter('lastName')"
              :validate-event="Boolean(form.lastName)"
              :placeholer="$t('login.register.lastName')"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item
        class="form-item-primary"
        prop="phone"
        v-if="tabType === 'phone'"
      >
        <!-- 手机号码 -->
        <BaseInput
          v-model="form.phone"
          :autofocus="!isMobile"
          :tabIndexNum="'3'"
          @blur="setAccount(form.phone)"
          :validate-event="Boolean(form.phone)"
          :placeholer="$t('login.loginPage.phoneNumber')"
          :maxLength="11"
        >
          <template #prepend>
            <el-select v-model="form.pretel" style="width: 100px" disabled>
              <el-option
                v-for="item in preTelList"
                :value="item"
                :label="'+' + item"
                :key="'+' + item.toString()"
                >+ {{ item }}</el-option
              >
            </el-select>
          </template>
        </BaseInput>
      </el-form-item>
      <el-form-item class="form-item-primary" prop="email" v-else>
        <!-- 邮箱 -->
        <BaseInput
          v-model="form.email"
          :placeholer="$t('login.loginPage.enterYourEmail')"
        />
      </el-form-item>
      <!-- 验证码 -->
      <el-form-item
        class="form-item-primary"
        prop="verification_code"
        v-if="tabType === 'phone'"
      >
        <BaseInput
          v-model="form.verification_code"
          :maxlength="smsLength"
          @focus="changeCode"
          :class="!isBinded ? 'is-binded' : 'no-binded'"
          :tabIndexNum="'4'"
          :placeholer="$t('login.loginPage.verificationCode')"
        >
          <template #btn>
            <VerificationCode
              ref="verification"
              @click="sendCode"
              :account="form.phone"
              :from="'bind'"
            />
          </template>
          <template #prefix>{{
            $t('login.loginPage.verificationCode')
          }}</template>
        </BaseInput>
      </el-form-item>
      <!-- 密码 -->
      <el-form-item
        v-else
        class="form-item-primary"
        prop="password"
        :class="{ 'higher-height': $i18n.locale === 'en' }"
      >
        <BaseInput
          v-model="form.password"
          type="password"
          :validate-event="Boolean(form.password)"
          :placeholer="$t('login.loginPage.passwords')"
        />
      </el-form-item>
    </el-form>

    <Agreement v-model="form.agreement" />

    <el-button class="button-custom" tabindex="5" @click="submit">{{
      $t('login.loginPage.enterEvent')
    }}</el-button>
  </div>
</template>

<script>
import BaseInput from '@/components/common/BaseInput.vue'
import VerificationCode from '@/components/login/VerificationCode.vue'
import Agreement from '@/components/login/Agreement'
import { handleFinalJump } from '@/utils/login.js'
import BaseMixin from '@/mixins/BaseMixin'
import AccountMixins from '@/mixins/AccountMixins.js'
import { getUserRegional } from '@/utils/locale.js'
import { checkPhone } from '@/utils/validate-rules'
import store from '@/store'
import { saveLoginInfo } from '@/utils'
import isObject from 'lodash/isObject'
import { MessageBox } from 'element-ui'
export default {
  name: '',
  props: {},
  data() {
    return {
      form: {
        agreement: true,
        firstName: '',
        lastName: '',
      },
      isWrong: false,
      tabType: '',
    }
  },

  components: { BaseInput, Agreement, VerificationCode },
  mixins: [BaseMixin, AccountMixins],
  computed: {
    rules() {
      return {
        email: [
          {
            required: true,
            message: this.$t('login.register.inputEmail'),
            trigger: 'blur',
          },
          {
            validator: async (rule, value, callback) => {
              let reg =
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              if (reg.test(value.toLowerCase())) {
                try {
                  let { data } = await store.dispatch('CheckUser', {
                    user_name: value,
                  })
                  if (data) {
                    store.commit('SET_BINDERROR', true)
                    return callback()
                  } else {
                    // 已注册的邮箱不能绑定
                    store.commit('SET_BINDERROR', false)
                    return callback(
                      new Error(this.$t('login.register.bindedEmail'))
                    )
                  }
                } catch (error) {
                  return callback()
                }
              }
              return callback(
                new Error(this.$t('login.register.needCanUseEmail'))
              )
            },
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t('login.register.inputPhone'),
            trigger: 'blur',
          },
          {
            validator: async (rule, value, callback) => {
              if (checkPhone(value)) {
                // try {
                //   let { data } = await store.dispatch('CheckUser', {
                //     user_name: value,
                //   })
                //   if (data) {
                //     store.commit('SET_BINDERROR', true)
                //     return callback()
                //   } else {
                //     // 已绑定的手机号不能再次绑定
                //     store.commit('SET_BINDERROR', false)
                //     return callback(
                //       new Error(this.$t('login.register.bindedPhone'))
                //     )
                //   }
                // } catch (error) {
                //   return callback()
                // }
                return callback()
              }
              return callback(
                // TODO: 文案确认
                new Error(this.$t('login.resetPassword.validPhone'))
              )
            },
            trigger: 'blur',
          },
        ],
        // lastName: [
        //   {
        //     required: true,
        //     message: this.$t('login.email.register.ruleLastName'),
        //     trigger: 'blur',
        //   },
        // ],
        // firstName: [
        //   {
        //     required: true,
        //     message: this.$t('login.email.register.ruleFirstName'),
        //     trigger: 'blur',
        //   },
        // ],
        verification_code: [
          {
            required: true,
            message: this.$t('login.register.labelCode'),
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (this.isWrong) {
                callback(
                  new Error(this.$t('login.loginPage.wrongSecurityCode'))
                )
              } else {
                callback()
              }
            },
          },
        ],
      }
    },
    isBinded() {
      return store.state.isBinded
    },
    smsLength() {
      return store.state.smsLength
    },
  },
  created() {
    this.getUserInfo()
    this.getUserRegional()
  },
  mounted() {},
  methods: {
    async getUserRegional() {
      const { type } = await getUserRegional()
      this.tabType = type || this.$route.params.type || 'phone'
    },
    changeCode() {
      this.isWrong = false
    },
    getUserInfo() {
      this.$api.login.GetUserInfo().then((data) => {
        if (data.code === 0) {
          this.form.firstName = data.data.properties.firstName || ''
          this.form.lastName = data.data.properties.lastName || ''
        }
      })
    },
    sendCode() {
      this.$refs['form'].validateField('phone', async (vaild) => {
        if (!vaild) {
          let { data } = await store.dispatch('CheckUser', {
            user_name: this.form.phone,
          })
          if (data) {
            // 未绑定
            this.$refs['verification'].send()
          } else {
            // 已绑定
            MessageBox.confirm(this.$t('login.loginPage.bindPhoneAgain'), '', {
              confirmButtonText: this.$t('login.loginPage.yes'),
              cancelButtonText: this.$t('login.loginPage.no'),
              showClose: false,
            })
              .then(() => {
                this.$router.push('/login/phone/detail')
              })
              .catch(() => {
                this.$refs['verification'].send()
              })
          }
        }
      })
    },
    back() {
      this.$router.push({
        path: '/register/phone/account',
        query: { ...this.$route.query },
      })
    },
    submit() {
      // 确认勾选隐私协议
      if (!this.form.agreement) {
        this.$message.error(this.$t('login.register.acceptTermsPop'))
        return
      }
      if (!this.form.firstName && !this.form.lastName) {
        this.$message.error(
          this.$i18n.locale === 'cn'
            ? '请填写姓和名'
            : 'first name or last name is required'
        )
        return
      }
      this.$refs['form'].validate(async (valid) => {
        try {
          if (valid) {
            const {
              phone,
              firstName,
              lastName,
              verification_code,
              email,
              password,
            } = this.form
            const phoneParams = {
              phone,
              firstName,
              lastName,
              verification_code,
            }
            const mailParams = {
              email,
              firstName,
              lastName,
              password,
            }

            let data
            if (this.tabType === 'phone') {
              data = await store.dispatch('BindPhone', phoneParams)
            } else {
              data = await store.dispatch('BindEmail', mailParams)
            }

            if (data.code === 0) {
              // 刷新 token 信息
              if (isObject(data?.data)) {
                saveLoginInfo(data?.data)
              }
              // 需要处理嘉宾和活动url
              handleFinalJump()
            }
          }
        } catch (error) {
          console.log(error, 'error')
          if (error.code === 11010) {
            this.isWrong = true
            this.$refs['form'].validateField('verification_code')
          }
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.login-btn-default {
  margin-top: 8px;
}
.form-custom {
  margin-top: 40px;
  margin-bottom: 40px;
}
.back-row {
  position: absolute;
  top: 31px;
  left: 34px;
  padding: 5px;
  cursor: pointer;
}
.is-binded {
  margin-top: 20px;
}
.no-binded {
  margin-top: unset;
}
</style>
